import { httpGet, httpPost, httpPut } from './httpService';
import appSettings from '../settings/appSettings';
import { IRole, IUserSearchResult } from 'shared/models/api/models';

const basePath = '/api/admin/';

const fullyQualifiedAndEncodedURL = (relativeUri: string) => {
    return new URL(basePath + encodeURI(relativeUri), appSettings.api.portalApi).toString();
};

const allowedDomainRoot = fullyQualifiedAndEncodedURL("allowed-domain-list");

export interface AllowedDomainListItem {
    id: number,
    contractPartner: string,
    isEnabled?: boolean | null
}

export interface AllowedDomain extends AllowedDomainListItem {
    sector: string,
    companyWebsite: string,
    emailDomain: string,
    contractManager: IUserSearchResult | null
}

export const emailDomainAvailable = async (emailDomain: string): Promise<boolean> => {
    return await httpGet<boolean>(`${allowedDomainRoot}/emailDomainAvailable/${emailDomain}`);
}

export const allowedDomainApi = {
    listAsync: async () =>
        await httpGet<AllowedDomainListItem[]>(`${allowedDomainRoot}/list`),
    getAsync: async (allowedDomainId: number) =>
        await httpGet<AllowedDomain>(`${allowedDomainRoot}/get/${allowedDomainId}`),
    addAsync: async (allowedDomain: AllowedDomain) =>
        await httpPut<AllowedDomain>(`${allowedDomainRoot}/add`, allowedDomain),
    updateAsync: async (allowedDomain: AllowedDomain) =>
        await httpPost<AllowedDomain>(`${allowedDomainRoot}/update`, allowedDomain),
    setIsEnabled: async (allowedDomainIds: number[], isEnabled: boolean) =>
        await httpPost<number>(`${allowedDomainRoot}/setIsEnabled/${isEnabled}`, allowedDomainIds)
};